import { useAuth } from '@contexts/AuthContext';
import { type LeagueKey, preferredLeagueKeyOrDefault } from '@parlay-picker/shared/league';

/** The league the user is browsing: the header selector's saved preference, else the in-season default. */
export function useCurrentLeagueKey(): LeagueKey {
  const { user } = useAuth();
  return preferredLeagueKeyOrDefault(user?.preferences?.preferredLeague);
}
